class AdpHeaderLogoTitleController {
  constructor() {
  }
}

export default AdpHeaderLogoTitleController;



// WEBPACK FOOTER //
// ./src/app/components/adpHeaderLogoTitle/adpHeaderLogoTitle.controller.js